import { BehaviorSubject } from 'rxjs';

const uuidSubject = new BehaviorSubject(undefined);
const pseudo_uuidSubject = new BehaviorSubject(undefined);
const session_idSubject = new BehaviorSubject(undefined);

export const uuid = {
  update: value => {
    uuidSubject.next(value);
  },
  subscribe: setState => uuidSubject.subscribe(setState),
  getValue: () => uuidSubject.value,
};

export const pseudo_uuid = {
  update: value => {
    pseudo_uuidSubject.next(value);
  },
  subscribe: setState => pseudo_uuidSubject.subscribe(setState),
  getValue: () => pseudo_uuidSubject.value,
};

export const session_id = {
  update: value => {
    session_idSubject.next(value);
  },
  subscribe: setState => session_idSubject.subscribe(setState),
  getValue: () => session_idSubject.value,
};
